import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { AiLabService } from '@/services/ai-lab-service';
import { reactive, computed, ref } from 'vue';
import { createGlobalState } from '@vueuse/core';

export const useAiLab = createGlobalState(() => {
    const aiLabService = reactive(injectService<AiLabService>(AiLabService));
    const hasAILabPermission = ref(false);
    const permissions = computed(() => {
        return aiLabService.permissions;
    });

    return {
        aiLabService,
        permissions,
        hasAILabPermission,
    };
});
